export default __webpack_public_path__ + "static/media/call-outbound.47d37dc9.svg";